import styled, { css } from 'styled-components';

import { AlgoliaSearchInput } from '@/components/AlgoliaSearchInput';
import { Flex } from '@/components/Flex';
import { SectionHeader } from '@/components/SectionHeader';

export const Header = styled(SectionHeader)`
  text-align: center;

  ${({ theme }) => css`
    margin-top: ${theme.spacing(3)};

    span {
      color: ${theme.colors.black};
    }
    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(2)};
    }
  `}
`;

export const SearchInput = styled(AlgoliaSearchInput)`
  max-width: 768px;
  margin: 0 auto;

  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(3)};

    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(4)};
    }
  `}
`;

export const ResultsWrapper = styled.div<{ $isActive: boolean }>`
  ${({ $isActive }) => css`
    display: ${$isActive ? 'block' : 'none'};
  `}
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(6)};

    ${theme.media.md.up} {
      margin-bottom: ${theme.spacing(8)};
    }
  `}
`;

export const AllTabSummaryWrapper = styled(Flex)`
  padding: ${({ theme }) => theme.spacing(2, 0)};
  justify-content: flex-end;
  font-size: ${({ theme }) => theme.fontSizes.p2};
`;
